export default {
      id: "ic_green_info-usage",
      viewBox: "0 0 50 51",
      url: "/" + "images/icons.3.109.2.svg#ic_green_info-usage",
      toString: function () {
        return this.url;
      }
    }